// Import why-did-you-render first, before any other React imports
// import './wdyr.js'; // Disabled to remove verbose logging
import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ThemeProvider } from './context/ThemeContext'
import { initGA } from './utils/analytics'
import './themes/themes.css'
import './themes/themeLoader'
import './print.css'
import ThemeRouterWrapper from './RouterWrapper'

// Fix for Chrome/Lighthouse "non-passive event listener" violations
// This makes all touch/wheel events passive by default, improving scroll performance
// and fixing scroll blocking issues on landing pages
(function() {
  if (typeof EventTarget !== "undefined") {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      if (type === 'touchstart' || type === 'touchmove' || type === 'wheel') {
        if (typeof options === 'object') {
          options.passive = options.passive !== undefined ? options.passive : true;
        } else if (options === undefined) {
          options = { passive: true };
        }
      }
      originalAddEventListener.call(this, type, listener, options);
    };
  }
})();

const enableProfile = new URLSearchParams(window.location.search).get('profile') === '1';
const onProfileRender = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
  console.log('[REACT_PROFILE]', JSON.stringify({ id, phase, actualDuration, baseDuration, startTime, commitTime }));
};

if (enableProfile) {
  globalThis.__REACT_PROFILE_ON_RENDER__ = onProfileRender;
}

// Initialize Google Analytics (only once)
if (!window.__GA_INITIALIZED__) {
  initGA();
  window.__GA_INITIALIZED__ = true;
}

// Guard against double initialization from HMR
if (!window.__REACT_ROOT__) {
  console.log('🚀 [main.jsx] Initializing React app...');
  
  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);
  window.__REACT_ROOT__ = root;
  
  const tree = (
    <ThemeRouterWrapper>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ThemeRouterWrapper>
  );
  
  root.render(
    enableProfile ? (
      <React.Profiler id="root" onRender={onProfileRender}>
        {tree}
      </React.Profiler>
    ) : tree
  );
} else {
  console.log('🔄 [main.jsx] HMR update - React root already exists, skipping re-initialization');
}
